<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nama</label>
          <b-form-input 
            v-model="filter.nama"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Dari Tanggal</label>
          <b-form-datepicker
            v-model="filter.dari_tanggal"
            :date-format="format"
            placeholder="dd-mm-yyyy"
          ></b-form-datepicker>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Sampai Tanggal</label>
          <b-form-datepicker
            v-model="filter.sampai_tanggal"
            :date-format="format"
            placeholder="dd-mm-yyyy"
          ></b-form-datepicker>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="cari()" class="mr-1">Cari</b-button>
          <!-- <b-button variant="outline-primary" @click="exportData()">Export</b-button> -->
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      filter: {
        nama: '',
        dari_tanggal: '',
        sampai_tanggal: ''
      },
      count: 0,
      format: 'DD-MM-YYYY'
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  methods: {
    cari() {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    },
    exportData() {
      // Implement export functionality here
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
